import { createStructuredSelector } from "reselect";
import {
    SUPPLIER_COM_SUPPLIER,
    SUPPLIER_COM_SUPPLIER_SUCCESS,
    SUPPLIER_COM_SUPPLIER_ERROR,
    SUPPLIER_COM_EMAIL,
    SUPPLIER_COM_EMAIL_SUCCESS,
    SUPPLIER_COM_EMAIL_ERROR,
    SUPPLIER_COM_PO,
    SUPPLIER_COM_PO_SUCCESS,
    SUPPLIER_COM_PO_ERROR,
    SUPPLIER_COM_CATEGORY,
    SUPPLIER_COM_CATEGORY_SUCCESS,
    SUPPLIER_COM_CATEGORY_ERROR,
    SUPPLIER_COMMUNICATION_LIST,
    SUPPLIER_COMMUNICATION_LIST_SUCCESS,
    SUPPLIER_COMMUNICATION_LIST_ERROR,
    SUPPLIER_COMMUNICATION_SEARCH_CHANGE,
    SUPPLIER_COMMUNICATION_PAGE_SET,
    SUPPLIER_COMMUNICATION_ADD_MODAL_SET,
    SUPPLIER_COMMUNICATION_ADD_SET_DATA,
    SUPPLIER_COMMUNICATION_ADD_CHANGE_SET,
    SUPPLIER_COMMUNICATION_ADD,
    SUPPLIER_COMMUNICATION_ADD_SUCCESS,
    SUPPLIER_COMMUNICATION_ADD_ERROR,
    SUPPLIER_COMMUNICATION_EDIT_MODAL_SET,
    SUPPLIER_COMMUNICATION_EDIT_SET_DATA,
    SUPPLIER_COMMUNICATION_EDIT_CHANGE_SET,
    SUPPLIER_COMMUNICATION_EDIT,
    SUPPLIER_COMMUNICATION_EDIT_SUCCESS,
    SUPPLIER_COMMUNICATION_EDIT_ERROR,
    SUPPLIER_COMMUNICATION_UPLOAD_SET,
    SUPPLIER_COMMUNICATION_UPLOAD_SET_SUCCESS,
    SUPPLIER_COMMUNICATION_UPLOAD_SET_ERROR,
    SUPPLIER_COMMUNICATION_UPLOAD_RESET,
    SUPPLIER_COMMUNICATION_SEE_MODAL_SET,
    SUPPLIER_COMMUNICATION_SEE_SET_DATA,
} from "../../actions";

export const NAME = 'supplierCommunication';

export const SupplierComSupplier = (data) => ({
    type: SUPPLIER_COM_SUPPLIER,
    payload: data
});

export const SupplierComSupplierSuccess = (data) => ({
    type: SUPPLIER_COM_SUPPLIER_SUCCESS,
    payload: data
});

export const SupplierComSupplierError = (error) => ({
    type: SUPPLIER_COM_SUPPLIER_ERROR,
    payload: error
});

export const SupplierComEmail = (data) => ({
    type: SUPPLIER_COM_EMAIL,
    payload: data
});

export const SupplierComEmailSuccess = (data) => ({
    type: SUPPLIER_COM_EMAIL_SUCCESS,
    payload: data
});

export const SupplierComEmailError = (error) => ({
    type: SUPPLIER_COM_EMAIL_ERROR,
    payload: error
});

export const SupplierComPO = (data) => ({
    type: SUPPLIER_COM_PO,
    payload: data
});

export const SupplierComPOSuccess = (data) => ({
    type: SUPPLIER_COM_PO_SUCCESS,
    payload: data
});

export const SupplierComPOError = (error) => ({
    type: SUPPLIER_COM_PO_ERROR,
    payload: error
});

export const SupplierComCategory = (data) => ({
    type: SUPPLIER_COM_CATEGORY,
    payload: data
});

export const SupplierComCategorySuccess = (data) => ({
    type: SUPPLIER_COM_CATEGORY_SUCCESS,
    payload: data
});

export const SupplierComCategoryError = (error) => ({
    type: SUPPLIER_COM_CATEGORY_ERROR,
    payload: error
});


export const SupplierCommunicationList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: SUPPLIER_COMMUNICATION_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const SupplierCommunicationListSuccess = (data) => ({
    type: SUPPLIER_COMMUNICATION_LIST_SUCCESS,
    payload: data
});

export const SupplierCommunicationListError = (error) => ({
    type: SUPPLIER_COMMUNICATION_LIST_ERROR,
    payload: error
});

export const SupplierCommunicationPageSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_PAGE_SET,
    payload: data
});

export const SupplierCommunicationSearchChange = (data) => ({
    type: SUPPLIER_COMMUNICATION_SEARCH_CHANGE,
    payload: data
});

export const SupplierCommunicationAddModalSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_ADD_MODAL_SET,
    payload: data
});

export const SupplierCommunicationAddSetData = (data) => ({
    type: SUPPLIER_COMMUNICATION_ADD_SET_DATA,
    payload: data
});


export const SupplierCommunicationAddChangeSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_ADD_CHANGE_SET,
    payload: data
});

export const SupplierCommunicationAdd = (page, num_page, orderBy, filters, data) => ({
    type: SUPPLIER_COMMUNICATION_ADD,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const SupplierCommunicationAddSuccess = (message) => ({
    type: SUPPLIER_COMMUNICATION_ADD_SUCCESS,
    payload: message
});

export const SupplierCommunicationAddError = (error) => ({
    type: SUPPLIER_COMMUNICATION_ADD_ERROR,
    payload: error
});

export const SupplierCommunicationEditModalSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_EDIT_MODAL_SET,
    payload: data
});

export const SupplierCommunicationEditSetData = (data) => ({
    type: SUPPLIER_COMMUNICATION_EDIT_SET_DATA,
    payload: data
});


export const SupplierCommunicationEditChangeSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_EDIT_CHANGE_SET,
    payload: data
});

export const SupplierCommunicationEdit = (page, num_page, orderBy, filters, data) => ({
    type: SUPPLIER_COMMUNICATION_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const SupplierCommunicationEditSuccess = (message) => ({
    type: SUPPLIER_COMMUNICATION_EDIT_SUCCESS,
    payload: message
});

export const SupplierCommunicationEditError = (error) => ({
    type: SUPPLIER_COMMUNICATION_EDIT_ERROR,
    payload: error
});
export const SupplierCommunicationUploadSet = (file) => ({
    type: SUPPLIER_COMMUNICATION_UPLOAD_SET,
    payload: { file },
});

export const SupplierCommunicationUploadSetSuccess = (items) => ({
    type: SUPPLIER_COMMUNICATION_UPLOAD_SET_SUCCESS,
    payload: items,
});

export const SupplierCommunicationUploadSetError = (error) => ({
    type: SUPPLIER_COMMUNICATION_UPLOAD_SET_ERROR,
    payload: error,
});

export const SupplierCommunicationUploadReset = () => ({
    type: SUPPLIER_COMMUNICATION_UPLOAD_RESET
});

export const SupplierCommunicationSeeModalSet = (data) => ({
    type: SUPPLIER_COMMUNICATION_SEE_MODAL_SET,
    payload: data
});

export const SupplierCommunicationSeeSetData = (data) => ({
    type: SUPPLIER_COMMUNICATION_SEE_SET_DATA,
    payload: data
});

const supplierCommunication = (state) => state[NAME];

export const SupplierCommunicationSelector = createStructuredSelector({
    supplierCommunication
})